import React from "react"
import Paper from "material-ui/Paper"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import ReactChartkick, { LineChart } from "react-chartkick"
import Chart from "chart.js"
import { CircularProgress } from "material-ui"
import { IPayrollTime } from "../../models"
import moment from "moment"
import * as timeHelper from "../../helpers/timeHelper"
import AccountStore from "../../stores/AccountStore"
ReactChartkick.addAdapter(Chart)
interface IProps {
	payrollData: IPayrollTime
	loading: boolean
}
interface IState {
	expanded: boolean
}

export default class PayrollHoursSummaryCard extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			expanded: false
		}
		autobind(this)
	}

	handleExpandCard() {
		this.setState({ expanded: !this.state.expanded })
	}

	getLineChartData(payrollData: IPayrollTime) {
		const lineChartData = {}
		payrollData &&
			payrollData.HoursSummary.HoursByDay.forEach((dayData, index) => {
				const day = moment(timeHelper.keepConvertUTCToLocal(payrollData.PayrollDates.StartDate)).add(index, "day").format("YYYY-MM-DD")
				lineChartData[day] = dayData
			})
		return lineChartData
	}

	getExpandedTotalHourFontSize(hour) {
		const hourDigitCount = Math.floor(hour).toString().length
		let fontSize
		switch (hourDigitCount) {
			case 7:
				fontSize = 29
				break
			case 6:
				fontSize = 32
				break
			case 5:
				fontSize = 36
				break
			case 4:
				fontSize = 43
				break
			default:
				fontSize = 50
				break
		}
		return fontSize
	}

	getExpandedHourFontSize(hour) {
		const hourDigitCount = Math.floor(hour).toString().length
		let fontSize
		switch (hourDigitCount) {
			case 7:
				fontSize = 17
				break
			case 6:
				fontSize = 18
				break
			case 5:
				fontSize = 20
				break
			case 4:
				fontSize = 23
				break
			default:
				fontSize = 26
				break
		}
		return fontSize
	}

	render() {
		const { payrollData, loading } = this.props
		const totalHours = loading ? 0 : payrollData.HoursSummary.TimeTotals.TotalProductiveHours
		const regHours = loading ? 0 : payrollData.HoursSummary.TimeTotals.RegularHours
		const OTHours = loading ? 0 : payrollData.HoursSummary.TimeTotals.OvertimeHours
		const OT2Hours = loading ? 0 : payrollData.HoursSummary.TimeTotals.DoubleOvertimeHours
		const expandedTotalHourStyle = Object.assign(styles.expandedTotalHour, { fontSize: this.getExpandedTotalHourFontSize(totalHours) })
		const expandedHourStyle = Object.assign(styles.expandedHour, { fontSize: this.getExpandedHourFontSize(regHours) })

		const lineChartData = this.getLineChartData(payrollData)
		return (
			<Paper
				data-intercom-target={"menu-Payroll-HoursSummaryExapansionPanel"}
				zDepth={1}
				className="page-paper"
				style={{ height: this.state.expanded ? 325 : 80, marginTop: -5, marginBottom: 25, paddingTop: 0 }}
			>
				<div style={{ position: "absolute", right: 15, top: 28, fontSize: 20 }}>
					<i
						data-intercom-target={"menu-Payroll-HoursSummary-Btn-Expand"}
						className={"fa " + (this.state.expanded ? "fa-chevron-up" : "fa-chevron-down") + " itemActionButton"}
						onClick={() => this.setState({ expanded: !this.state.expanded })}
					/>
				</div>
				{this.state.expanded ?
					<div style={{ padding: "5px 35px" }}>
						<div style={styles.expandedTitle}>{strings.Payroll_Hours_Summary}</div>
						{loading ?
							<div style={{ textAlign: "center", marginTop: 100 }}>
								<CircularProgress />
							</div> :
							<div>
								<div style={styles.expandedCirclePart}>
									<div style={{ display: "inline-block", bottom: 0, position: "absolute", marginLeft: -300 }}>
										<div style={{ textAlign: "center", width: 170, height: 170, borderRadius: "50%", border: "15px solid rgb(175, 190, 197)" }}>
											{payrollData &&
												<div style={styles.expandedTotalCirle}>
													<div style={expandedTotalHourStyle as React.CSSProperties}>{totalHours}</div>
													<div style={styles.expandedTotalHourType}>{strings.TotalHours}</div>
												</div>
											}
										</div>
									</div>
									<div style={{ display: "inline-block", bottom: 0, position: "absolute", marginLeft: -90 }}>
										<div style={{ textAlign: "center", width: 95, height: 95, borderRadius: "50%", border: "15px solid #dae2e5" }}>
											{payrollData &&
												<div style={styles.expandedTotalCirle}>
													<div style={expandedHourStyle as React.CSSProperties}>{regHours}</div>
													<div style={styles.expandedHourType}>{strings.Reg_Hours}</div>
												</div>
											}
										</div>
									</div>
									<div style={{ display: "inline-block", bottom: 0, position: "absolute", marginLeft: 40 }}>
										<div style={{ textAlign: "center", width: 95, height: 95, borderRadius: "50%", border: "15px solid #dae2e5" }}>
											{payrollData &&
												<div style={styles.expandedTotalCirle}>
													<div style={expandedHourStyle as React.CSSProperties}>{OTHours}</div>
													<div style={styles.expandedHourType}>{strings.OT_Hours}</div>
												</div>
											}
										</div>
									</div>
									{!AccountStore.getHideOT2() &&
										<div style={{ display: "inline-block", bottom: 0, position: "absolute", marginLeft: 170 }}>
											<div style={{ textAlign: "center", width: 95, height: 95, borderRadius: "50%", border: "15px solid #dae2e5" }}>
												{payrollData &&
													<div style={styles.expandedTotalCirle}>
														<div style={expandedHourStyle as React.CSSProperties}>{OT2Hours}</div>
														<div style={styles.expandedHourType}>{strings.OT2_Hours}</div>
													</div>
												}
											</div>
										</div>
									}
								</div>
								<div style={styles.expandedLineChartPart}>
									<div style={styles.chartTitle}>{strings.Total_Hours_By_Day}</div>
									<LineChart
										data={lineChartData}
										width={"100%"}
										height={220}
										ytitle={strings.Hours_Worked}
										label={strings.Hour}
									/>
								</div>
							</div>
						}
					</div> :
					<div style={{ display: "flex" }}>
						<div style={{ fontSize: 15, fontWeight: "bold", width: 200, textAlign: "center", paddingTop: 31 }}>
							{strings.Payroll_Hours_Summary}
						</div>
						<div style={{ flex: 1, backgroundColor: "rgb(231, 231, 231)", height: 80 }}>
							{loading ?
								<div style={{ textAlign: "center", marginTop: 20 }}>
									<CircularProgress />
								</div> :
								<div>
									<div style={styles.collapsedHoursGroup}>
										<div style={styles.collapsedHour}>{totalHours}</div>
										<div style={styles.collapsedHourType}>{strings.TotalHours.toUpperCase()}</div>
									</div>
									<div style={styles.collapsedHoursGroup}>
										<div style={styles.collapsedHour}>{regHours}</div>
										<div style={styles.collapsedHourType}>{strings.Reg_Hours.toUpperCase()}</div>
									</div>
									<div style={styles.collapsedHoursGroup}>
										<div style={styles.collapsedHour}>{OTHours}</div>
										<div style={styles.collapsedHourType}>{strings.OT_Hours.toUpperCase()}</div>
									</div>
									{!AccountStore.getHideOT2() &&
										<div style={styles.collapsedHoursGroup}>
											<div style={styles.collapsedHour}>{OT2Hours}</div>
											<div style={styles.collapsedHourType}>{strings.OT2_Hours.toUpperCase()}</div>
										</div>
									}
								</div>
							}
						</div>
						<div style={{ width: 50 }} />
					</div>
				}
			</Paper>
		)
	}
}

const styles = {
	collapsedHoursGroup: {
		width: "25%",
		display: "inline-block",
		textAlign: "center"
	},
	collapsedHour: {
		fontSize: 30,
		fontWeight: "bold" as "bold",
		marginTop: 30
	},
	collapsedHourType: {
		marginTop: 6,
		color: "rgba(0, 0, 0, 0.5)"
	},
	expandedTitle: {
		fontSize: 15,
		fontWeight: 500 as 500,
		paddingTop: 15
	},
	expandedCirclePart: {
		width: "45%",
		minWidth: 600,
		float: "left",
		marginTop: 35,
		height: "200px",
		position: "relative" as "relative",
		textAlign: "center"
	},
	expandedLineChartPart: {
		minWidth: 550,
		width: "45%",
		float: "right",
		marginTop: 15,
		marginRight: 20
	},
	expandedTotalCirle: {
		display: "inline-block",
		textAlign: "center"
	},
	expandedTotalHour: {
		fontWeight: 500,
		marginTop: 70
	},
	expandedTotalHourType: {
		marginTop: 13,
		color: "rgba(0, 0, 0, 0.5)"
	},
	expandedHour: {
		fontWeight: 400,
		marginTop: 35
	},
	expandedHourType: {
		color: "rgba(0, 0, 0, 0.5)",
		fontSize: 10
	},
	chartTitle: {
		textAlign: "center",
		fontSize: 16,
		marginBottom: 20
	}
}